// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__P6kN-","option":"styles_option__Y9jA9","radio":"styles_radio__9D2J8"};